export enum StructureNameEnum {
  "木造（W）" = "木造（W）",
  "鉄骨造（S）" = "鉄骨造（S）",
  "軽量鉄骨造（S）" = "軽量鉄骨造（S）",
  "鉄筋コンクリート造（RC）" = "鉄筋コンクリート造（RC）",
  "鉄骨鉄筋コンクリート造（SRC）" = "鉄骨鉄筋コンクリート造（SRC）",
  "コンクリートブロック造（RCB）" = "コンクリートブロック造（RCB）",
  "その他" = "その他"
}
